/*
properties:
 * fonts type: fontTypes_main, fontTypes_secondary
 * font size: fontSizes_large, fontSizes_largesecondary, fontSizes_medium ,fontSizes_mediumsecondary, fontSizes_small, fontSizes_smallsecondary
 * colors: colors_main, colors_darkmain, colors_secondary, colors_base01, colors_base02, colors_base03, colors_base04
 * Text alignment: textAlignment.
 * corner radium: Xpx
 * Icons: icons_x, icons_login, icons_password, icons_fullscreenon, icons_fullscreenoff, icons_agelimit18, icons_agelimit21
 * Overlay: lightbox_bgcolor, lightbox_bgopacity
*/
const BRANDED_THEMES = {
    "0_111": [
        {'className': 'cgp-themes-main-title', properties: [{name: 'color', value: 'colors_base04'}]},
    ]
}



const THEMES_CLASSES_LIST = [
    /* login inputs */
    {'className': 'input[type="text"].cgp-themes-login-form-input, input[type="text"].cgp-themes-login-form-input', properties: [
        {name: 'background-color', value: 'colors_base05'},
        {name: 'border-left-color', value: 'colors_main'},
        {name: 'border-bottom-color', value: 'colors_darkmain'},
        {name: 'font-size', value: 'fontsizes_large3d'},
        {name: 'font-family', value: 'fontTypes_main'},
        {name: 'color', value: 'colors_base01'}
        ]},
    {'className': 'input[type="text"].cgp-themes-login-form-input, input[type="text"].cgp-themes-login-form-input:focus', properties: [
        {name: 'background-color', value: 'colors_base05'},
        {name: 'border-left-color', value: 'colors_main'},
        {name: 'border-bottom-color', value: 'colors_darkmain'},
        {name: 'font-size', value: 'fontsizes_large3d'},
        {name: 'font-family', value: 'fontTypes_main'},
        {name: 'color', value: 'colors_base01'}
    ]},
    {'className': 'input[type="password"].cgp-themes-login-form-input, input[type="password"].cgp-themes-login-form-input', properties: [
        {name: 'background-color', value: 'colors_base05'},
        {name: 'border-left-color', value: 'colors_main'},
        {name: 'border-bottom-color', value: 'colors_darkmain'},
        {name: 'font-size', value: 'fontsizes_large3d'},
        {name: 'font-family', value: 'fontTypes_main'},
        {name: 'color', value: 'colors_base01'}
    ]},
    {'className': 'input[type="password"].cgp-themes-login-form-input, input[type="password"].cgp-themes-login-form-input:focus', properties: [
        {name: 'background-color', value: 'colors_base05'},
        {name: 'border-left-color', value: 'colors_main'},
        {name: 'border-bottom-color', value: 'colors_darkmain'},
        {name: 'font-size', value: 'fontsizes_large3d'},
        {name: 'font-family', value: 'fontTypes_main'},
        {name: 'color', value: 'colors_base01'}
    ]},

    /* GUI Keys Titles*/
    {'className': 'cgp-themes-main-title', properties: [
        {name: 'font-family', value: 'fontTypes_secondary'},
        {name: 'font-size', value: 'fontsizes_large3d'},
        {name: 'color', value: 'colors_main'}
        ]},
    {'className': 'cgp-themes-main-title.cgp-modal-themes-main-title', properties: [
            {name: 'font-family', value: 'fontTypes_secondary'},
            {name: 'font-size', value: 'fontsizes_large3d'},
            {name: 'color', value: 'colors_base01'}
        ]},
    {'className': 'cgp-themes-main-title2', properties: [
        {name: 'font-family', value: 'fontTypes_secondary'},
        {name: 'font-size', value: 'fontsizes_large'},
        {name: 'color', value: 'colors_base01'}
        ]},
    {'className': 'cgp-themes-secondary-title', properties: [
        {name: 'font-family', value: 'fontTypes_main'},
        {name: 'font-size', value: 'fontsizes_medium'},
        {name: 'color', value: 'colors_secondary'}
    ]},
    {'className': 'cgp-themes-big-title', properties: [
        {name: 'font-family', value: 'fontTypes_main'},
        {name: 'font-size', value: 'fontsizes_xlarge'},
        {name: 'color', value: 'colors_main'}
        ]},

    /* GUI Keys Texts*/
    {'className': 'cgp-themes-main-text', properties: [
        {name: 'font-family', value: 'fontTypes_main'},
        {name: 'font-size', value: 'fontsizes_medium'},
        {name: 'color', value: 'colors_base01'}
        ]},
    {'className': 'cgp-msg-content .cgp-themes-main-text', properties: [
            {name: 'font-family', value: 'fontTypes_main'},
            {name: 'font-size', value: 'fontsizes_medium'},
            {name: 'color', value: 'colors_base01'}
        ]},
    {'className': 'cgp-themes-secondary-text', properties: [
        {name: 'font-family', value: 'fontTypes_main'},
        {name: 'font-size', value: 'fontsizes_large3d'},
        {name: 'color', value: 'colors_base01'}
        ]},
    {'className': 'cgp-themes-small-text', properties: [
        {name: 'font-family', value: 'fontTypes_main'},
        {name: 'font-size', value: 'fontsizes_small'},
        {name: 'color', value: 'colors_base02'}
        ]},
    {'className': 'cgp-themes-grayed-out-text', properties: [
        {name: 'font-family', value: 'fontTypes_main'},
        {name: 'font-size', value: 'fontsizes_mediumsecondary'},
        {name: 'color', value: 'colors_base02'}
        ]},
    {'className': 'cgp-themes-small-secondary-grayed-out-text', properties: [
        {name: 'font-family', value: 'fontTypes_main'},
        {name: 'font-size', value: 'fontsizes_smallsecondary'},
        {name: 'color', value: 'colors_base02'}
    ]},
    {'className': 'cgp-themes-error-text', properties: [
        {name: 'font-family', value: 'fontTypes_main'},
        {name: 'font-size', value: 'fontsizes_medium'},
        {name: 'color', value: 'colors_base04'}
        ]},
    {'className': 'cgp-themes-large-text', properties: [
        {name: 'font-family', value: 'fontTypes_secondary'},
        {name: 'font-size', value: 'fontsizes_medium'},
        {name: 'color', value: 'colors_base01'}
        ]},
    {'className': 'cgp-themes-grayed-out-text-placeholder::placeholder', properties: [
        {name: 'font-family', value: 'fontTypes_main'},
        {name: 'font-size', value: 'fontsizes_mediumSecondary'},
        {name: 'color', value: 'colors_base02'}
        ]},

    /* GUI Keys CTAs */
    {'className': 'cgp-themes-main-cta', properties: [
        {name: 'font-family', value: 'fontTypes_type04'},
        {name: 'font-size', value: 'fontSizes_mediumsecondary'},
        {name: 'color', value: 'colors_darkmain'},
        {name: 'background-color', value: 'colors_secondary'},
        {name: 'border-radius', value: 'ctacornerradius'}
        ]},
    {'className': 'cgp-themes-main-cta.cgp-modal-button', properties: [
        {name: 'font-family', value: 'fontTypes_type04'},
        {name: 'font-size', value: 'fontSizes_mediumsecondary'},
        {name: 'color', value: 'colors_darkmain'},
        {name: 'background-color', value: 'colors_main'},
        {name: 'border-radius', value: 'ctacornerradius'},
            {name: 'border-color', value: 'colors_main'}
        ]},
    {'className': 'cgp-pc .cgp-themes-main-cta:hover', properties: [
        {name: 'color', value: 'colors_secondary'},
        {name: 'background-color', value: 'colors_darkmain'},
        {name: 'border-color', value: 'colors_secondary'},
        {name: 'border-width', value: 'bordersize'}
        ]},
    {'className': 'cgp-pc .cgp-themes-main-cta.cgp-modal-button:hover', properties: [
            {name: 'font-family', value: 'fontTypes_type04'},
            {name: 'font-size', value: 'fontSizes_mediumsecondary'},
            {name: 'color', value: 'colors_main'},
            {name: 'background-color', value: 'colors_darkmain'},
            {name: 'border-radius', value: 'ctacornerradius'},
            {name: 'border-color', value: 'colors_main'}
        ]},
    {'className': 'cgp-themes-secondary-cta', properties: [
        {name: 'font-family', value: 'fontTypes_type04'},
        {name: 'font-size', value: 'fontsizes_mediumSecondary'},
        {name: 'color', value: 'colors_main'},
        {name: 'background-color', value: 'colors_base05'},
        {name: 'border-color', value: 'colors_main'},
        {name: 'border-radius', value: 'ctacornerradius'},
        {name: 'border-width', value: 'bordersize'}
        ]},
    {'className': 'cgp-pc .cgp-themes-secondary-cta:hover', properties: [
        {name: 'color', value: 'colors_darkmain'},
        {name: 'background', value: 'colors_main'}
        ]},
    {'className': 'cgp-themes-base-cta', properties: [
        {name: 'font-family', value: 'fontTypes_type04'},
        {name: 'font-size', value: 'fontsizes_mediumSecondary'},
        {name: 'color', value: 'colors_base01'},
        {name: 'background-color', value: 'colors_base05'},
        {name: 'border-color', value: 'colors_base02'},
        {name: 'border-radius', value: 'ctacornerradius'},
        {name: 'border-width', value: 'bordersize'}
        ]},
    {'className': 'cgp-themes-base-cta.cgp-modal-button', properties: [
            {name: 'font-family', value: 'fontTypes_type04'},
            {name: 'font-size', value: 'fontsizes_mediumSecondary'},
            {name: 'color', value: 'colors_base02'},
            {name: 'background-color', value: 'colors_darkmain'},
            {name: 'border-color', value: 'colors_base02'},
            {name: 'border-radius', value: 'ctacornerradius'},
            {name: 'border-width', value: 'bordersize'}
        ]},
    {'className': 'cgp-pc .cgp-themes-base-cta:hover', properties: [
        {name: 'color', value: 'colors_darkmain'},
        {name: 'background-color', value: 'colors_base01'}
        ]},
    {'className': 'cgp-pc .cgp-themes-base-cta.cgp-modal-button:hover', properties: [
            {name: 'color', value: 'colors_darkmain'},
            {name: 'background-color', value: 'colors_base02'},
            {name: 'border-radius', value: 'ctacornerradius'}
        ]},
    {'className': 'cgp-themes-small-base-cta', properties: [
        {name: 'font-family', value: 'fontTypes_secondary'},
        {name: 'font-size', value: 'fontsizes_small'},
        {name: 'color', value: 'colors_darkmain'},
        {name: 'background', value: 'colors_base01'},
        {name: 'border-radius', value: 'ctacornerradius'}
        ]},
    {'className': 'cgp-pc .cgp-themes-small-base-cta:hover', properties: [
        {name: 'color', value: 'colors_secondary'},
        {name: 'background', value: 'colors_darkmain'},
        {name: 'border-color', value: 'colors_secondary'},
        {name: 'border-width', value: 'bordersize'}
        ]},

    {'className': 'cgp-themes-small-secondary-cta', properties: [
        {name: 'font-family', value: 'fontTypes_main'},
        {name: 'font-size', value: 'fontsizes_mediumsecondary'},
        {name: 'color', value: 'colors_secondary'},
        {name: 'background', value: 'colors_main'},
        {name: 'border-radius', value: 'ctacornerradius'},
        {name: 'border-width', value: 'bordersize'},
        {name: 'border-color', value: 'colors_secondary'}
    ]},
    {'className': 'cgp-pc .cgp-themes-small-secondary-cta:hover', properties: [
        {name: 'color', value: 'colors_darkmain'},
        {name: 'background', value: 'colors_base01'}
    ]},
    {'className': 'cgp-themes-3rd-cta', properties: [
        {name: 'font-family', value: 'fontTypes_secondary'},
        {name: 'font-size', value: 'fontsizes_small'},
        {name: 'color', value: 'colors_secondary'},
        {name: 'background', value: 'colors_base05'},
        {name: 'border-radius', value: 'ctacornerradius'},
        {name: 'border-width', value: 'bordersize'},
        {name: 'border-color', value: 'colors_secondary'}
    ]},
    {'className': 'cgp-pc button.cgp-themes-3rd-cta:hover', properties: [
            {name: 'color', value: 'colors_darkmain'},
            {name: 'border-color', value: 'colors_secondary'},
            {name: 'background-color', value: 'colors_secondary'}
        ]},

    /* Arrows */

    {'className': 'cgp-themes-icons-right-arrow', properties: [{name: 'background-image', value: 'icons_rightarrow'}]},
    {'className': 'cgp-themes-icons-left-arrow', properties: [{name: 'background-image', value: 'icons_leftarrow'}]},
    {'className': 'cgp-themes-icons-up-arrow', properties: [{name: 'background-image', value: 'icons_uparrow'}]},
    {'className': 'cgp-themes-icons-down-arrow', properties: [{name: 'background-image', value: 'icons_downarrow'}]},
    /* Free Play message styles*/
    {'className': 'cgp-themes-icons-fp-voucher-back', properties: [{name: 'background-image', value: 'icons_fpvoucherback'}]},
    {'className': 'cgp-themes-icons-fp-voucher-newbadge ', properties: [{name: 'background-image', value: 'icons_fpvouchernewbadge'}]},
    {'className': 'cgp-themes-icons-fp-voucher-free-play ', properties: [{name: 'background-image', value: 'icons_fpvoucherfreeplay'}]},
    {'className': 'cgp-themes-icons-fp-voucher-free-spin ', properties: [{name: 'background-image', value: 'icons_fpvoucherfreespin'}]},
    {'className': 'cgp-themes-icons-fp-voucher-jackpot-free-play ', properties: [{name: 'background-image', value: 'icons_fpvoucherjackpotfreeplay'}]},
    {'className': 'cgp-themes-icons-fp-voucher-jackpot-free-spin ', properties: [{name: 'background-image', value: 'icons_fpvoucherjackpotfreespin'}]},
    {'className': 'cgp-themes-icons-fp-voucher-info-open ', properties: [{name: 'background-image', value: 'icons_fpvoucherinfoopen'}]},
    {'className': 'cgp-themes-icons-fp-voucher-info-close', properties: [{name: 'background-image', value: 'icons_fpvoucherinfoclose'}]},
    {'className': 'cgp-themes-vouchers-bg', properties: [{name: 'background-image', value: 'icons_fp_vouchers_bg'}]},
    {'className': 'cgp-themes-icons-fp-right-arrow', properties: [{name: 'background-image', value: 'icons_fp_right_arrow'}]},
    {'className': 'cgp-themes-icons-fp-left-arrow', properties: [{name: 'background-image', value: 'icons_fp_left_arrow'}]},
    {'className': 'cgp-themes-icons-fp-voucher-bg-free-play', properties: [{name: 'background-image', value: 'icons_fp_voucher_bg_free_play'}]},
    {'className': 'cgp-themes-icons-fp-voucher-bg-free-spin', properties: [{name: 'background-image', value: 'icons_fp_voucher_bg_free_spin'}]},
    {'className': 'cgp-themes-icons-fp-voucher-bg-jackpot-free-spin', properties: [{name: 'background-image', value: 'icons_fp_voucher_bg_jackpot_free_spin'}]},
    {'className': 'cgp-themes-icons-fp-voucher-bg-jackpot-free-play', properties: [{name: 'background-image', value: 'icons_fp_voucher_bg_jackpot_free_play'}]},
    {'className': 'cgp-themes-fp-games-container-title-background', properties: [{name: 'border-bottom-color', value: 'colors_base05'}]},
    {'className': 'cgp-themes-item-dot', properties: [{name: 'background', value: 'colors_base01'}]},
    {'className': 'cgp-themes-fp-games-container-title', properties: [{name: 'font-size', value: 'fontSizes_small'}]},
    {'className': 'cgp-fp-expiration.cgp-theme-property-color-base04', properties: [{name: 'background-color', value: 'colors_darkMain'}]},
    {'className': 'cgp-themes-property-icons-touch-finger', properties: [{name: 'background-image', value: 'icons_touchFinger'}]},

    /* Toaster message*/
    {'className': 'CGPToasterLayout > .iziToast-cover.cgp-general-notification-toaster-icon', properties: [{name: 'background-image', value: 'icons_toastergeneralmessage'}, {name: 'background-color', value: 'colors_base05'}]},
    {'className': 'iziToast.CGPToasterLayout', properties: [{name: 'border-color', value: 'colors_base05'}]},


    /* Post-Pre Login*/
    {'className': 'cgp-themes-icons-password', properties: [{name: 'background', value: 'icons_password'}]},
    {'className': 'cgp-themes-icons-username', properties: [{name: 'background-image', value: 'icons_username'}]},
    {'className': 'cgp-themes-icons-new-member-left', properties: [{name: 'background-image', value: 'icons_newmemberleft'}]},
    {'className': 'cgp-themes-icons-new-member-right', properties: [{name: 'background-image', value: 'icons_newmemberright'}]},
    {'className': 'cgp-themes-property-icons-post-login-mobile', properties: [{name: 'background-image', value: 'icons_postloginmobile'}]},
    {'className': 'cgp-themes-touch-id-auto-enabled-cta', properties: [{name: 'background-color', value: 'colors_main'},{name: 'color', value: 'colors_darkMain'}]},

    {'className': 'cgp-theme-property-history-table-width-pc', properties: [{name: 'max-width', value: 'historytable_sizepc'}]},
    {'className': 'cgp-theme-property-lightbox-background-color', properties: [{name: 'background', value: 'lightboxbgcolor'}]},
    {'className': 'cgp-theme-property-corner-radius', properties: [{name: 'border-radius', value: 'ctacornerradius'}]},

    // Last-Login
    {'className': 'cgp-themes-directive-last_login', properties: [{name: 'color', value: 'base05'}]},

    // X close
    {'className': 'iziToast.CGPToasterLayout>.iziToast-close', properties: [
            {name: 'background-image', value: 'icons_xclose01'}
        ]},
    {'className': 'cgp-themes-icons-x', properties: [
        {name: 'width', value: 'modalCloseButtonSize'},
        {name: 'height', value: 'modalCloseButtonSize'},
        {name: 'background-image', value: 'icons_xclose01'}
    ]},
    {'className': 'cgp-themes-icons-x:hover', properties: [{name: 'opacity', value: 'xMouseoverOpcaity'}]},
    {'className': 'cgp-themes-icons-x-no-header:hover', properties: [{name: 'opacity', value: 'xMouseoverOpcaity'}]},
    {'className': 'cgp-themes-icons-x-no-header', properties: [{name: 'background-image', value: 'icons_xclose02'}]},

    /* Game Frame*/
    {'className': 'cgp-themes-icons-fullscreen-on', properties: [{name: 'background-image', value: 'icons_fullscreenon'}]},
    {'className': 'cgp-themes-icons-fullscreen-off', properties: [{name: 'background-image', value: 'icons_fullscreenoff'}]},
    {'className': 'cgp-themes-icons-age-limit-21-round', properties: [{name: 'background-image', value: 'icons_agelimit21round'}]},
    {'className': 'cgp-themes-icons-age-limit-21-flat', properties: [{name: 'background-image', value: 'icons_agelimit21flat'}]},
    {'className': 'cgp-themes-icons-age-limit.cgp-themes-icons-age-limit-18-capsule', properties: [{name: 'background-image', value: 'icons_agelimit18capsule'}]},
    {'className': 'cgp-themes-icons-age-limit-18-round', properties: [{name: 'background-image', value: 'icons_agelimit18round'},{name: 'width', value: 'iconswidth_agelimit18round'}, {name: 'height', value: 'iconsheight_agelimit18flat'}]},
    {'className': 'cgp-themes-icons-age-limit-18-flat', properties: [{name: 'background-image', value: 'icons_agelimit18flat'}, {name: 'width', value: 'iconswidth_agelimit18flat'}, {name: 'height', value: 'iconsheight_agelimit18flat'}]},
    {'className': 'cgp-mobile .cgp-themes-icons-age-limit-18-round', properties: [{name: 'width', value: 'iconswidthmobile_agelimit18round'}, {name: 'height', value: 'iconsheightmobile_agelimit18round'}]},
    {'className': 'cgp-mobile .cgp-themes-icons-age-limit-18-flat', properties: [{name: 'width', value: 'iconswidthmobile_agelimit18flat'}, {name: 'height', value: 'iconsheightmobile_agelimit18flat'}]},
    {'className': 'cgp-themes-icons-placeholder-game', properties: [{name: 'background-image', value: 'icons_gamebackground'}]},
    {'className': 'cgp-themes-property-icons-vertical-line-glow', properties: [{name: 'background-image', value: 'icons_verticalLineGlow'}]},
    {'className': 'cgp-themes-icons-game-frame-fp-indicator', properties: [{name: 'background-image', value: 'icons_gameframefpindicator'}]},
    {'className': 'cgp-themes-icons-gameframe-bg-fp-left', properties: [{name: 'background-image', value: 'icons_gameframebgfpleft'}]},
    {'className': 'cgp-themes-icons-gameframe-bg-fp-right', properties: [{name: 'background-image', value: 'icons_gameframebgfpright'}]},
    {'className': 'cgp-themes-icons-gameframe-bg-real-left', properties: [{name: 'background-image', value: 'icons_gameframebgrealleft'}]},
    {'className': 'cgp-themes-icons-gameframe-bg-real-right', properties: [{name: 'background-image', value: 'icons_gameframebgrealright'}]},
    {'className': 'cgp-themes-icons-gameframe-bg-demo-left', properties: [{name: 'background-image', value: 'icons_gameframebgdemoleft'}]},
    {'className': 'cgp-themes-icons-gameframe-bg-demo-right', properties: [{name: 'background-image', value: 'icons_gameframebgdemoright'}]},

    {'className': 'cgp-property-gameframe-real-size', properties: [{name: 'width', value: 'gameFrameRealSize'}]},
    {'className': 'cgp-property-gameframe-anon-size', properties: [{name: 'width', value: 'gameFrameAnonSize'}]},
    {'className': 'cgp-property-gameframe-anon-horizontal-position', properties: [{name: 'align-items', value: 'gameframeanonhorizontalposition'}]},
    {'className': 'cgp-property-gameframe-real-horizontal-position', properties: [{name: 'align-items', value: 'gameframerealhorizontalposition'}]},

    /* History table */
    {'className': 'cgp-themes-icons-history-calendar', properties: [{name: 'background-image', value: 'icons_historycalendar'}]},
    {'className': 'cgp-themes-icons-details-left-corner', properties: [{name: 'background-image', value: 'icons_historydetailsleftcorner'}]},
    {'className': 'cgp-themes-history-from-last-days-select', properties: [
            {name: 'background-color', value: 'colors_darkMain'},
            {name: 'border-color', value: 'colors_base05'}
        ]
    },
    {'className': 'cgp-themes-history-from-last-days-select:focus', properties: [
            {name: 'background-color', value: 'colors_darkMain'},
            {name: 'border-color', value: 'colors_base05'}
        ]
    },
    {'className': 'cgp-themes-history-icons-down-arrow', properties: [{name: 'background-image', value: 'icons_downarrowhistory'}]},
    {'className': 'cgp-history .cgp-title', properties: [{name: 'background-color', value: 'historyPage_titleBackgroundColor'}]},
    {'className': 'cgp-history .cgp-history-table-area', properties: [{name: 'background-color', value: 'historyPage_itemsListBackgroundColor'}]},
    {'className': 'cgp-history .cgp-game-date', properties: [{name: 'color', value: 'historyPage_dateTextColor'}]},
    {'className': 'cgp-history .cgp-game-body-more-details', properties: [{name: 'background-color', value: 'historyPage_showMoreBackgroundColor'}]},
    {'className': 'cgp-history .cgp-to-details', properties: [{name: 'color', value: 'historyPage_showMoreTextColor'}]},


    /* DropDownBox */
    {'className': 'cgp-themes-drop-down-box', properties: [
            {name: 'border-color', value: 'colors_base02'},
            {name: 'background-color', value: 'colors_base05'}

        ]
    },
    {'className': 'cgp-themes-drop-down-box:focus', properties: [
            {name: 'background-color', value: 'colors_base05'},
            {name: 'border-color', value: 'colors_base02'}
        ]
    },

    /* Reminder */
    {'className': 'cgp-themes-reminder-selector', properties: [
            {name: 'border-color', value: 'colors_base02'},
            {name: 'background-color', value: 'colors_base05'}

        ]
    },
    {'className': 'cgp-themes-reminder-selector:focus', properties: [
            {name: 'background-color', value: 'colors_base05'},
            {name: 'border-color', value: 'colors_base02'}
        ]
    },
    {'className': 'cgp-themes-plus-minus-button i:before', properties: [
            {name: 'background', value: 'colors_base01'},
        ]
    },
    {'className': 'cgp-themes-plus-minus-button i:after', properties: [
            {name: 'background', value: 'colors_base01'},
        ]
    },

    /* Inactivity timeout settings */
    {'className': 'select.cgp-themes-inactivity-timeout-selector', properties: [
        {name: 'border-color', value: 'colors_base02'},
        {name: 'background-color', value: 'colors_base05'}
    ]},

    {'className': 'cgp-themes-icons-login-form-tab', properties: [{name: 'background-image', value: 'icons_loginformtab'}]},

   {'className': 'cgp-themes-icons-login-mobile', properties: [{name: 'background-image', value: 'icons_loginmobile'}]},
   {'className': 'cgp-themes-icons-default-game', properties: [{name: 'background-image', value: 'icons_default_game'}]},

   {'className': 'cgp-theme-property-background-color-main', properties: [{name: 'background-color', value: 'colors_main'}]},

   {'className': 'cgp-themes-property-icons-touch-finger', properties: [{name: 'background-image', value: 'icons_touchfinger'}]},

    /* Font types properties*/
    {'className': 'cgp-theme-property-font-type-main', properties: [{name: 'font-family', value: 'fontTypes_main'}]},
    {'className': 'cgp-theme-property-font-type-secondary', properties: [{name: 'font-family', value: 'fontTypes_secondary'}]},
    {'className': 'cgp-theme-property-font-type-3', properties: [{name: 'font-family', value: 'fontTypes_type03'}]},
    {'className': 'cgp-theme-property-font-type-4', properties: [{name: 'font-family', value: 'fontTypes_type04'}]},
    {'className': 'cgp-theme-property-font-type-5', properties: [{name: 'font-family', value: 'fontTypes_type05'}]},
    {'className': 'cgp-theme-property-font-type-6', properties: [{name: 'font-family', value: 'fontTypes_type06'}]},
    {'className': 'cgp-theme-property-font-type-7', properties: [{name: 'font-family', value: 'fontTypes_type07'}]},

    /* text link */
    {'className': 'cgp-themes-link', properties: [{name: 'color', value: 'colors_main'}]},
    {'className': 'cgp-themes-link:link', properties: [{name: 'color', value: 'colors_main'}]},
    {'className': 'cgp-themes-link:visited', properties: [{name: 'color', value: 'colors_main'}]},
    {'className': 'cgp-themes-link:hover', properties: [{name: 'color', value: 'colors_main'}]},

    /* Font sizes properties*/
    {'className': 'cgp-theme-property-font-size-xlarge', properties: [{name: 'font-size', value: 'fontsizes_xlarge'}]},
    {'className': 'cgp-theme-property-font-size-large', properties: [{name: 'font-size', value: 'fontsizes_large'}]},
    {'className': 'cgp-theme-property-font-size-large-secondary', properties: [{name: 'font-size', value: 'fontsizes_largesecondary'}]},
    {'className': 'cgp-theme-property-font-size-medium', properties: [{name: 'font-size', value: 'fontsizes_medium'}]},
    {'className': 'cgp-theme-property-font-size-medium-secondary', properties: [{name: 'font-size', value: 'fontsizes_mediumsecondary'}]},
    {'className': 'cgp-theme-property-font-size-small', properties: [{name: 'font-size', value: 'fontsizes_small'}]},
    {'className': 'cgp-theme-property-font-size-small-secondary', properties: [{name: 'font-size', value: 'fontsizes_smallsecondary'}]},
    {'className': 'cgp-theme-property-font-size-xxxlarge', properties: [{name: 'font-size', value: 'fontsizes_xxxlarge'}]},
    {'className': 'cgp-theme-property-font-size-xxlarge', properties: [{name: 'font-size', value: 'fontsizes_xxlarge'}]},
    {'className': 'cgp-theme-property-font-size-large3d', properties: [{name: 'font-size', value: 'fontsizes_large3d'}]},
    {'className': 'cgp-theme-property-font-size-xsmall', properties: [{name: 'font-size', value: 'fontsizes_xsmall'}]},

    /* Text alignment property */
    {'className': 'cgp-theme-property-text-align', properties: [{name: 'text-align', value: 'textalignment'}]},

    /* Corner radius properties*/
    {'className': 'cgp-theme-property-cta-corner-radius', properties: [{name: 'border-radius', value: 'ctacornerradius'}]},
    {'className': 'cgp-theme-property-lb-corner-radius', properties: [{name: 'border-radius', value: 'lbcornerradius'}]},
    /* Border size property */
    {'className': 'cgp-theme-property-border-size', properties: [{name: 'border-width', value: 'bordersize'}]},

    /* Full border properties */
    {'className': 'cgp-theme-property-border-color-main', properties: [{name: 'border-color', value: 'colors_main'}]},
    {'className': 'cgp-theme-property-border-color-secondary', properties: [{name: 'border-color', value: 'colors_secondary'}]},
    {'className': 'cgp-theme-property-border-color-base02', properties: [{name: 'border-color', value: 'colors_base02'}]},
    /* Bottom border properties*/
    {'className': 'cgp-theme-property-border-bottom-color-main', properties: [{name: 'border-bottom-color', value: 'colors_main'}]},
    {'className': 'cgp-theme-property-border-bottom-color-base03', properties: [{name: 'border-bottom-color', value: 'colors_base03'}]},
    {'className': 'cgp-theme-property-border-bottom-color-base04', properties: [{name: 'border-bottom-color', value: 'colors_base04'}]},
    {'className': 'cgp-theme-property-border-bottom-color-darkmain', properties: [{name: 'border-bottom-color', value: 'colors_darkmain'}]},
    /* Left border properties */
    {'className': 'cgp-theme-property-border-left-color-main', properties: [{name: 'border-left-color', value: 'colors_main'}]},
    {'className': 'cgp-theme-property-border-left-color-base03', properties: [{name: 'border-left-color', value: 'colors_base03'}]},
    {'className': 'cgp-theme-property-border-left-color-base04', properties: [{name: 'border-left-color', value: 'colors_base04'}]},
    {'className': 'cgp-theme-property-border-left-color-base05', properties: [{name: 'border-left-color', value: 'colors_base05'}]},
    /* Background properties */
    {'className': 'cgp-theme-property-background-color-base01', properties: [{name: 'background-color', value: 'colors_base01'}]},
    {'className': 'cgp-theme-property-background-color-base03', properties: [{name: 'background-color', value: 'colors_base03'}]},
    {'className': 'cgp-theme-property-background-color-base04', properties: [{name: 'background-color', value: 'colors_base04'}]},
    {'className': 'cgp-theme-property-background-color-base05', properties: [{name: 'background-color', value: 'colors_base05'}]},
    {'className': 'cgp-theme-property-background-color-secondary', properties: [{name: 'background-color', value: 'colors_secondary'}]},
    {'className': 'cgp-theme-property-background-color-darkmain', properties: [{name: 'background-color', value: 'colors_darkmain'}]},
    {'className': 'cgp-modal-theme-property-background-color', properties: [{name: 'background-color', value: 'colors_darkmain'}]},
    {'className': 'cgp-theme-property-background-color-main', properties: [{name: 'background-color', value: 'colors_main'}]},
    {'className': 'cgp-theme-property-message-title-decoration', properties: [{name: 'background', value: 'colors_messageTitleDecoration'}]},
    /* Colors properties*/
    {'className': 'cgp-theme-property-color-main', properties: [{name: 'color', value: 'colors_main'}]},
    {'className': 'cgp-theme-property-color-dark-main', properties: [{name: 'color', value: 'colors_darkMain'}]},
    {'className': 'cgp-theme-property-color-secondary', properties: [{name: 'color', value: 'colors_secondary'}]},
    {'className': 'cgp-theme-property-color-base01', properties: [{name: 'color', value: 'colors_base01'}]},
    {'className': 'cgp-theme-property-color-base02', properties: [{name: 'color', value: 'colors_base02'}]},
    {'className': 'cgp-theme-property-color-base03', properties: [{name: 'color', value: 'colors_base03'}]},
    {'className': 'cgp-theme-property-color-base04', properties: [{name: 'color', value: 'colors_base04'}]},
    {'className': 'cgp-theme-property-color-base05', properties: [{name: 'color', value: 'colors_base05'}]},
    {'className': 'cgp-theme-property-color-dark-grey', properties: [{name: 'color', value: 'colors_darkGrey'}]},
    {'className': 'cgp-theme-property-color-dark-white', properties: [{name: 'color', value: 'colors_darkWhite'}]},

];

const THEMES_DEFAULTS = {
    FONT_TYPES: {
        'Main': 'Arial',
        'Secondary': 'Arial',
        'Type03': 'Arial',
        'Type04': 'Arial',
        'Type05': 'Arial',
        'Type06': 'Arial'
    },
    FONT_SIZES: {
        'xxxLarge': 20,
        'xxLarge': 22,
        'xLarge': 20,
        'large': 18,
        'largeSecondary': 17,
        'medium': 15,
        'mediumSecondary': 14,
        'small': 13,
        'smallSecondary': 11,
        'Large3D': 16
    },
    COLORS: {
        'main': '#7ff800',
        'darkMain': '#000000',
        'secondary': '#fce403',
        'base01': '#ffffff',
        'base02': '#717171',
        'base03': '#232323',
        'base04': '#ff014f',
        'base05': '#171717',
        'base06': '#323232',
        'base07': "#000000",
        'base08': "#ffffff",
        'darkGrey': '#555555',
        'darkWhite': '#d3d3d3'
    },
    CAPTCHA_THEME: 'dark'
};

const THEMES_LIMITS = {
    FONT_SIZES: {
        'xxxLarge': 36,
        'xxLarge': 26,
        'xLarge': 30,
        'large': 25,
        'largeSecondary': 25,
        'medium': 20,
        'mediumSecondary': 20,
        'small': 20,
        'smallSecondary': 20,
        'Large3D': 20
    }
}
export {THEMES_CLASSES_LIST, BRANDED_THEMES, THEMES_DEFAULTS, THEMES_LIMITS};